var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m194.8,286.5l46.8,51.6c7.8,8.5 22.6,8.5 30.4,0l46.8-51.6 119.8,128.7h-363.6l119.8-128.7zm-27.5-30.3l-115,123.5v-250.4l115,126.9zm89.5,38l-178.9-197.4h357.7l-178.8,197.4zm204.3-164.9v250.4l-115-123.5 115-126.9zm19.4-73.3h-449c-11.3,0-20.5,9.1-20.5,20.4v359.2c0,11.3 9.2,20.4 20.5,20.4h448.9c11.3,0 20.5-9.1 20.5-20.4v-359.2c0.1-11.3-9.1-20.4-20.4-20.4z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.42fe45d20eca53f3284e54b7e2b0438b.svg";
export { ForwardRef as ReactComponent };